import { home } from '@project/api/home/v1'
import { navAndFooter } from '@project/api/nav-and-footer/v1'

export default {
  async home() {
    return await home()
  },
  async navAndFooter() {
    return await navAndFooter()
  },
}

